
import { defineComponent, onMounted, PropType, Ref, ref, watch } from 'vue'

import useValidationMessages from '@/common/composable/useValidationMessages'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    props: {
        name: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        autoheight: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        cols: {
            type: Number,
            default: null,
        },
        rows: {
            type: Number,
            default: null,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const textarea = ref(null) as Ref<null | HTMLTextAreaElement>

        const autoResize = () => {
            if (!textarea.value) return
            const textarea_scrollheight = textarea.value.scrollHeight

            if (!props.value || props.value === '') {
                textarea.value.style.setProperty('height', 'auto')
            } else {
                textarea.value.style.setProperty('height', `${textarea_scrollheight}px`)
            }
        }

        const emitInput = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('update:value', target.value)
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('change', target.value)
        }

        onMounted(() => {
            if (!props.autoheight || !textarea.value) return
            autoResize()
        })

        if (props.autoheight) {
            watch(
                () => props.value,
                () => {
                    setTimeout(autoResize, 100)
                }
            )
        }

        const { getValidationMessage } = useValidationMessages()

        return { textarea, emitInput, emitChange, getValidationMessage }
    },
})
